<script lang="ts" setup>

interface Props {
  incrementCount: number;
  disabled: boolean;
}

const props = defineProps<Props>();

const windowSize = defineModel<number>({ required: true });

</script>

<template>
  <IonInfiniteScroll
    :disabled="disabled"
    @ion-infinite="(e) => {
      windowSize += incrementCount;
      e.target.complete()
    }"
  >
    <slot>
      <IonInfiniteScrollContent />
    </slot>
  </IonInfiniteScroll>
</template>

<style scoped>

</style>
